import { render } from "./Home.vue?vue&type=template&id=4acb90f3&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=4acb90f3&lang=scss&scoped=true"

import exportComponent from "/Users/benjaminjehl/projects/letterdropz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acb90f3"]])

export default __exports__